/**
 * Copies a given string to the clipboard using
 * the modern clipboard API with fallback
 *
 * @param content The content to be copied
 * @returns Promise that resolves when copy succeeds or rejects on error
 */
export async function copyToClipboard(content: string): Promise<void> {
  if (navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(content)
    } catch (error) {
      // Fallback to legacy method if modern API fails
      return fallbackCopyToClipboard(content)
    }
  } else {
    return fallbackCopyToClipboard(content)
  }
}

/**
 * Fallback clipboard copy method using document.execCommand
 */
function fallbackCopyToClipboard(content: string): void {
  const dummy = document.createElement("textarea")
  document.body.appendChild(dummy)
  dummy.value = content
  dummy.select()
  const success = document.execCommand("copy")
  document.body.removeChild(dummy)
  if (!success) {
    throw new Error("Failed to copy to clipboard")
  }
}
